/** 未登录创作页展示的创作案例（与控制台创作案例同源） */
export const AIGC_GUEST_SHOWCASE = [
  {
    id: "guest-1",
    taskType: "video",
    cover:
      "https://xmyd-poster.huanzhou.art/tos-vod-cn-v-fafd3f231a0a2836/oQ3wMBm40AWuSHKesOUiTKEoSgb8qv1T0GIGZ1~tplv-vod-noop.jpg",
    url:
      "https://xmyd-vod.huanzhou.art/5d237ecf0a834e0c81fc4626d708c45e.mp4?a=0&br=2939&bt=2939&cd=0%7C0%7C0&ch=0&cr=0&cs=0&dr=0&ds=4&eid=v0d243g10065d5u5fualjhtdlcf1qcrg&er=0&l=20260130150428CB89531FB15ABCCADFD2&lr=&mime_type=video_mp4&net=0&pl=0&qs=13&rc=amY0Zmdrb3g4ODgzNDY1M0ApdXRpb3dtZGl4ZzkzajdneWdvbmNpcWdeY3JhMy1kMWFzc2RgLmBhZWlyMjIyLS4wLy06Yw%3D%3D&vl=&vr=",
  },
  {
    id: "guest-2",
    taskType: "image",
    url:
      "https://xmyd-poster.huanzhou.art/tos-vod-cn-v-fafd3f231a0a2836/ows1ImdquLtE1sSGazk0ABeZL544PkTgKjpilA~tplv-vod-noop.jpg",
  },
  {
    id: "guest-3",
    taskType: "video",
    cover:
      "https://crea-img.xinzhiyun.net/upload/works/1s2evin7wa9.mp4?vframe/jpg/offset/0",
    url: "https://crea-img.xinzhiyun.net/upload/works/1s2evin7wa9.mp4",
  },
  {
    id: "guest-4",
    taskType: "image",
    url:
      "https://xmyd-poster.huanzhou.art/tos-vod-cn-v-fafd3f231a0a2836/oI3VtBm40ACZfqv9sR7QiKEuSgcSKaYTcGIqDS~tplv-vod-noop.image",
  },
  {
    id: "guest-5",
    taskType: "video",
    cover:
      "https://crea-img.xinzhiyun.net/upload/works/adi1359ejhq.mp4?vframe/jpg/offset/0",
    url: "https://crea-img.xinzhiyun.net/upload/works/adi1359ejhq.mp4",
  },
  {
    id: "guest-6",
    taskType: "video",
    cover:
      "https://crea-img.xinzhiyun.net/upload/works/90a802r2mtp.mp4?vframe/jpg/offset/0",
    url: "https://crea-img.xinzhiyun.net/upload/works/90a802r2mtp.mp4",
  },
];



// WEBPACK FOOTER //
// ./src/views/aigc/aigcGuestShowcase.js